import { render, staticRenderFns } from "./killcomboTable.vue?vue&type=template&id=a015c530"
import script from "./killcomboTable.vue?vue&type=script&lang=js"
export * from "./killcomboTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports